export default "/images/sunset.svg?56dee25c133f98abf50458f9e6eff282";